import getApiClient from '@/plugins/api'
import moment from "moment/moment";

export default {
  loadItem() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    self.$store.commit('startLoading')

    api.get(`coupons/${itemId}`, {
      params: self.searchParams
    })
      .then((result) => {
        self.coupon = result.data
      })
      .catch((error) => {
        console.log(error)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  save() {
    const self = this,
      api = getApiClient(self.$root.$store),
      itemId = self.$route.params.id

    let method = 'post',
      endpoint = 'coupons',
      headers = {}

    if (itemId) {
      method = 'patch'
      endpoint = `coupons/${itemId}`
      headers['Content-Type'] = 'application/merge-patch+json'
    }

    if (!self.coupon.maxUsesPerPerson) {
      self.coupon.maxUsesPerPerson = null
    }

    if (!self.coupon.quantity) {
      self.coupon.quantity = null
    }

    if (!self.coupon.validFrom) {
      self.coupon.validFrom = null
    }

    if (!self.coupon.validUntil) {
      self.coupon.validUntil = null
    }

    if (!self.coupon.amount) {
      self.coupon.amount = 0
    }

    self.success = false
    self.error = false
    self.errors = {}
    self.$store.commit('startLoading')
    api[method](endpoint, self.coupon, {headers: headers})
      .then(response => {
        self.coupon = response.data
        self.success = true
        if (method === 'post') {
          self.$router.push({
            name: 'Editar cupom',
            params: {
              id: self.coupon.code
            }
          })
        }
      })
      .catch(error => {
        self.error = true
        self.processErrors(error.response.data.violations)
      })
      .finally(() => {
        self.$store.commit('stopLoading')
      })
  },

  parseDate(dateString, format) {
    if (dateString.length >= 16) {
      return moment(dateString, format).toDate()
    }
  },

  processErrors(errors) {
    const self = this
    self.errors = {}

    errors.forEach(error => {
      self.errors[error.propertyPath] = error.message
    })
  },

  setType: function(type) {
    this.coupon.type = type.toString()
  },

  setFirstPurchaseOnly: function(event) {
    this.coupon.firstPurchaseOnly = event.target.checked
  },

  setPaymentMethod: function(paymentMethod) {
    this.coupon.paymentMethod = paymentMethod.toString()
  },
}
